<template>
  <div>
    <div
      class="flex items-center bg-green-500 text-white px-4 py-3 mb-8 relative"
      role="alert"
    >
      <i class="fas fa-check"></i>
      <div class="ml-4">
        <span>
          {{ message }}
        </span>
      </div>
      <button
        class="absolute top-0 right-0 mt-2 mr-4 focus:outline-none"
        @click.prevent="$emit('close')"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["message"],
};
</script>
